import institutionAPI from 'services/institutionAPI'

type Params = {
  professionalContractTypeId: string
}

export default async function getProfessionalContractTypeOnCustomForm({ professionalContractTypeId }: Params) {
  const response = await institutionAPI({
    method: 'GET',
    url: `/citizen-portal/contract-type/contract-type/${professionalContractTypeId}`,
  })

  return response
}
